import * as React from 'react';
import styled from "styled-components";
import {transparentize} from "polished";
import {transition} from "helpers/css";

export interface FilterProps {
  defaultValue: string | number;
  onChange: (value: string | number) => void;
  items: {
    label: string,
    value: string | number,
  }[];
}

const Container = styled.div`
  background-color: ${({theme}) => theme.variables.backgroundColor};
  display: flex;
  width: max-content;
  border-radius: 5px;
  overflow: hidden;

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.01em;

`;

const Item = styled.div<{active?: boolean}>`
  cursor: pointer;
  padding: 7px 12px;
  color: ${({theme, active}) => active && theme.colors.white};
  background-color: ${({active, theme}) => active
      ? theme.colors.primary
      : 'transparent'
  };
  
  &:hover {
    background-color: ${({active, theme}) => active
        ? theme.colors.primary
        : transparentize(.3, theme.variables.accentBackgroundColor)
    };
  }
  
  ${transition()};
`;

export default function Filter(props: FilterProps) {

  function onClickHandler(value: string | number) {
    props.onChange(value)
  }

  function renderItems() {
    return props.items.map(item => (
      <Item
        active={props.defaultValue === item.value}
        onClick={() => onClickHandler(item.value)}
      >
        {item.label}
      </Item>
    ))
  }

  return (
    <Container>
      {renderItems()}
    </Container>
  )
}
